import { useState } from "react";
import { useLocation } from "react-router-dom";
import { EditBulkClassMutation } from "src/api/Class";
import { BorderButton } from "src/components/buttons/BorderButton";
import InputRadio from "src/components/inputs/InputRadio";
import { InputRadioGroup } from "src/components/inputs/InputRadioGroup";
import { apiClient } from "src/stores/Api";
import { useStore } from "src/stores/Store";
import message from "src/utils/message";
import { modals, useModal } from "src/utils/modals";
import { bulkClass, editBulkClassVariables } from "types/code-generator";
import Modal from "./Modal";

interface Props {
  counts: bulkClass["bulkClass"];
  onNetworkAction: () => void;
}

export const BulkEditAllowNonMembersModal = modals.create((props: Props) => {
  const modal = useModal();
  const location = useLocation();
  const store = useStore();
  const [allow, setAllow] = useState(null);

  async function onSubmit() {
    const variables: editBulkClassVariables = {
      data: {
        allowNonMembers: allow,
      },
      where: {
        organizationId: store.organization.id,
      },
      filter: location.search,
    };

    const processingMessage = message.loading("Updating");

    await apiClient(EditBulkClassMutation, {
      variables,
    });

    processingMessage();
    message.success("Updated!");

    if (props.onNetworkAction) {
      props.onNetworkAction();
    }

    onCancel();
  }

  function onCancel() {
    modal.hide();
  }

  const enabled = props.counts.allowNonMembers;

  return (
    <Modal
      visible={modal.visible}
      afterClose={modal.remove}
      title="Allow Non-members"
      handleCancel={onCancel}
      footer={
        <>
          <BorderButton type="submit" onClick={onSubmit}>
            Save & Apply
          </BorderButton>
          <BorderButton onClick={onCancel}>Cancel</BorderButton>
        </>
      }
    >
      <p>
        Of the selected {props.counts.total.toLocaleString()} offerings,{" "}
        {enabled.toLocaleString()} have this setting enabled.
      </p>

      <hr />

      <div>
        <InputRadioGroup onChange={setAllow} value={allow}>
          <InputRadio
            value={true}
            label={`Enable non-members for all ${props.counts.total.toLocaleString()} offering${
              props.counts.total !== 1 && "s"
            }`}
          />
          <InputRadio
            value={false}
            label={`Disable non-members for all ${props.counts.total.toLocaleString()} offering${
              props.counts.total !== 1 && "s"
            }`}
          />
        </InputRadioGroup>
      </div>
    </Modal>
  );
});
